import React, { useState, useEffect } from "react";
import { toast } from "../ui/use-toast";
import EditableCalendar from "./EditableCalendar";
import ReadOnlyCalendar from "./ReadOnlyCalendar";

export default function AvailabilityCalendar({
  setAvailabilityForm,
  availability,
  setAvailability,
  timezone,
  setTimezone,
}) {
  const [timezoneOffset, setTimezoneOffset] = useState(null);

  const [show, setShow] = useState(
    window.location.href.includes("consultant") ? true : false
  );

  useEffect(() => {
    setTimezoneOffset(new Date().getTimezoneOffset() / -60);
    loadAvailability();
  }, []);

  useEffect(() => {
    // Update timezone offset when timezone changes
    const date = new Date();
    const offset = -date.getTimezoneOffset() / 60;
    setTimezoneOffset(offset);
  }, [timezone]);

  const toggleAvailability = (startDate, startHour, endDate, endHour) => {
    const slots = [];
    let currentDate = new Date(startDate);
    while (currentDate <= endDate) {
      let hour = currentDate.getTime() === startDate.getTime() ? startHour : 0;
      const endHourForDay =
        currentDate.getTime() === endDate.getTime() ? endHour : 23;
      while (hour <= endHourForDay) {
        const timestamp = createUnixTimestamp(
          currentDate,
          hour,
          timezoneOffset
        );
        slots.push(timestamp);
        hour++;
      }
      currentDate.setDate(currentDate.getDate() + 1);
    }

    setAvailability((prev) => {
      const newAvailability = [...prev];
      slots.forEach((slot) => {
        const index = newAvailability.indexOf(slot);
        if (index > -1) {
          newAvailability.splice(index, 1);
        } else {
          newAvailability.push(slot);
        }
      });
      return newAvailability;
    });
  };

  const loadAvailability = () => {
    try {
      const storedData = localStorage.getItem("availabilityData");
      if (storedData) {
        setAvailability(JSON.parse(storedData));
      }
    } catch (error) {
      console.error("Error loading availability data:", error);
      toast({
        title: "Error",
        description: "Failed to load availability data",
        variant: "destructive",
      });
    }
  };

  return (
    <div className="space-y-8">
      {show ? (
        <EditableCalendar
          availability={availability}
          timezoneOffset={timezoneOffset}
          setTimezoneOffset={setTimezoneOffset}
          setTimezone={setTimezone}
          timezone={timezone}
          toggleAvailability={toggleAvailability}
          show={show}
          setShow={setShow}
          setAvailabilityForm={setAvailabilityForm}
          setAvailability={setAvailability}
        />
      ) : (
        <ReadOnlyCalendar
          availability={availability}
          show={show}
          setShow={setShow}
          setAvailabilityForm={setAvailabilityForm}
        />
      )}
    </div>
  );
}

export const createUnixTimestamp = (date, hour, timezoneOffset) => {
  const newDate = new Date(date);
  newDate.setHours(hour, 0, 0, 0);

  // Ajustar la fecha según la zona horaria
  const localOffset = newDate.getTimezoneOffset() / 60;
  const adjustedHours = hour - localOffset + timezoneOffset;
  newDate.setHours(adjustedHours);

  return Math.floor(newDate.getTime() / 1000);
};
